import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=601ed21c&scoped=true&"
var script = {}
import style0 from "./FooterMobile.vue?vue&type=style&index=0&id=601ed21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601ed21c",
  null
  
)

export default component.exports